export interface NewsItem {
  id: number;
  category: string;
  date: string;
  title: string;
  summary: string;
  content: string;
  image: string;
  tag: string;
}

export const newsData: NewsItem[] = [
  {
    id: 1,
    category: 'プレスリリース',
    date: '2025年6月10日',
    title: '東京都千代田区・大型オフィスビル新築工事の軽鉄下地LGS工事を受注いたしました',
    summary: '東京都千代田区に建設中の地上20階建て大型オフィスビルにおける軽鉄下地LGS工事を受注しました。延床面積約3,200㎡に及ぶ大規模施工を、高い精度と安全管理のもとで進めてまいります。',
    content: `株式会社永恒は、東京都千代田区に建設中の地上20階建て大型オフィスビル新築工事において、軽鉄下地LGS工事を受注いたしました。

本工事は、天井・壁の全面にわたるLGS下地組みを施工するもので、延床面積は約3,200㎡に及ぶ大規模プロジェクトです。

【工事概要】
・工事名：千代田区大型オフィスビル新築内装工事（LGS下地工事）
・所在地：東京都千代田区
・施工面積：約3,200㎡
・工期：2025年7月〜2025年10月（予定）
・施工内容：天井LGS下地組み・壁LGS下地組み・耐震天井工法対応

【施工のポイント】
1. 高精度な墨出し・レベル調整
大規模施工においても、ミリ単位の精度を維持した墨出し・レベル調整を徹底します。後工程のボード工事・クロス工事がスムーズに進む高品質な下地を提供します。

2. 耐震天井工法への対応
本工事では、メーカー認定の耐震天井工法を採用します。ブレース・特殊金具を用いた補強施工により、大規模地震時の天井落下リスクを最小化します。

3. 安全管理の徹底
高所作業が多い本工事では、安全管理を最優先に施工体制を構築します。全作業員への安全教育・KY活動を徹底し、無事故・無災害での完工を目指します。

4. 後工程との連携
ボード工事・クロス工事を担当する協力会社と密に連携し、工程全体の効率化を図ります。一貫施工による工期短縮と品質向上を実現します。

株式会社永恒は、今後も高品質な内装仕上工事の提供を通じて、お客様の建築プロジェクトに貢献してまいります。

【お問い合わせ】
株式会社永恒 営業部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://public.readdy.ai/ai/img_res/f25ae9395f5f4e6f9c36e3a9256f104d.jpg',
    tag: 'hot',
  },
  {
    id: 2,
    category: 'プレスリリース',
    date: '2025年5月20日',
    title: '東京都港区・大型オフィスリノベーション工事（約2,400㎡）が竣工いたしました',
    summary: '東京都港区の大型オフィスビルにおける内装リノベーション工事（LGS工事・ボード工事・壁紙クロス工事・床仕上工事）が竣工いたしました。施主様より品質・工期ともに高い評価をいただきました。',
    content: `株式会社永恒が施工を担当した、東京都港区の大型オフィスビル内装リノベーション工事（約2,400㎡）が、2025年5月15日に無事竣工いたしました。

施主様・元請け会社様より「品質・工期・安全管理のすべてにおいて高い水準を維持していただいた」との評価をいただきました。

【工事概要】
・工事名：港区大型オフィスビル内装リノベーション工事一式
・所在地：東京都港区
・施工面積：約2,400㎡（全8フロア）
・工期：2025年2月〜2025年5月（約3ヶ月）
・施工内容：LGS下地工事・ボード工事・壁紙クロス工事・床仕上工事

【各工事の施工ポイント】
1. 軽鉄下地LGS工事
既存躯体への影響を最小限に抑えながら、精度の高い下地組みを実現しました。オフィスの用途に合わせた間仕切り壁・天井下地を施工しています。

2. ボード工事
会議室・個室エリアには遮音性能の高い石膏ボード二重張りを採用。執務エリアには軽量化を考慮したシングル張りを使い分けました。

3. 壁紙クロス工事
フロアごとにコンセプトカラーを設定し、機能性と意匠性を両立したクロスを選定。エントランスには高級感のある織物調クロスを採用しました。

4. 床仕上工事
執務エリアにはタイルカーペット、エントランス・廊下には長尺シートを施工。防音・歩行感にも配慮した仕上げを実現しました。

【施主様からのコメント】
「短工期の中でも品質を妥協せず、美しい仕上がりで完工していただきました。社員からも新しいオフィス環境への満足度が高く、大変感謝しています。」
（不動産管理会社 担当者様）

【お問い合わせ】
株式会社永恒 営業部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://readdy.ai/api/search-image?query=completed%20modern%20office%20interior%20renovation%20Tokyo%20Japan%20open%20plan%20workspace%20elegant%20wallpaper%20tile%20carpet%20flooring%20gypsum%20ceiling%20partition%20walls%20professional%20finish%20bright%20clean%20contemporary%20office%20design%20high%20quality%20craftsmanship%20no%20people&width=800&height=500&seq=news-office-reno-002&orientation=landscape',
    tag: 'hot',
  },
  {
    id: 3,
    category: 'イベント',
    date: '2025年5月10日',
    title: '内装仕上工事 技術見学会・現場体験会のご案内（6月開催）',
    summary: '弊社施工現場にて、軽鉄下地LGS工事・ボード工事・壁紙クロス工事の技術見学会を開催いたします。職人の技を間近でご覧いただける貴重な機会です。建設業関係者・学生の方のご参加をお待ちしております。',
    content: `株式会社永恒は、2025年6月14日（土）に弊社施工現場にて、内装仕上工事の技術見学会・現場体験会を開催いたします。

軽鉄下地LGS工事・ボード工事・壁紙クロス工事・床仕上工事の実際の施工現場を見学いただけるほか、一部工程では参加者の方にも体験していただける内容となっております。

【開催概要】
・日時：2025年6月14日（土）10:00〜15:00
・会場：弊社施工現場（東京都内・詳細はお申込み後にご案内）
・定員：20名（先着順）
・参加費：無料
・対象：建設業関係者、建築系学生、内装工事に興味のある方

【プログラム】
10:00〜10:30　受付・安全装備の着用
10:30〜11:00　会社概要・施工内容の説明
11:00〜12:00　LGS下地工事 見学・体験
12:00〜13:00　昼食（弊社提供）
13:00〜14:00　ボード工事・壁紙クロス工事 見学・体験
14:00〜14:30　床仕上工事 見学
14:30〜15:00　質疑応答・個別相談

【見学・体験内容】
1. 軽鉄下地LGS工事
ランナー・スタッドの取り付け方法、レベル調整の技術、耐震金具の取り付けなどを実際に見学・体験いただけます。

2. ボード工事
石膏ボードの張り付け方法、ジョイント処理、コーナー処理などの技術を間近でご覧いただけます。

3. 壁紙クロス工事
クロスの裁断・糊付け・張り付けの工程、継ぎ目処理の技術などを見学・体験いただけます。

4. 床仕上工事
フローリング・長尺シートの施工方法、下地処理の重要性などについて解説いたします。

【参加特典】
・弊社施工事例集（カタログ）プレゼント
・採用情報のご案内（就職・転職希望者向け）
・個別相談会への参加権（希望者のみ）

【お申込み・お問い合わせ】
株式会社永恒 総務部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://readdy.ai/api/search-image?query=interior%20construction%20site%20tour%20workers%20demonstrating%20professional%20techniques%20gypsum%20board%20installation%20wallpaper%20application%20floor%20finishing%20Japanese%20construction%20company%20training%20event%20safety%20helmets%20bright%20modern%20building%20interior&width=800&height=500&seq=news-event-003&orientation=landscape',
    tag: '',
  },
  {
    id: 4,
    category: 'プレスリリース',
    date: '2025年4月18日',
    title: '横浜市・大型マンション新築工事（全120戸）の内装仕上工事一式を受注',
    summary: '神奈川県横浜市に建設中の大型マンション（全120戸）において、LGS工事・ボード工事・壁紙クロス工事・床仕上工事の内装仕上工事一式を受注いたしました。2025年秋の竣工に向けて施工を進めてまいります。',
    content: `株式会社永恒は、神奈川県横浜市に建設中の大型マンション新築工事（全120戸）において、内装仕上工事一式（LGS工事・ボード工事・壁紙クロス工事・床仕上工事）を受注いたしました。

本プロジェクトは弊社にとって過去最大規模の受注案件の一つであり、全工程を自社施工・管理体制で対応いたします。

【工事概要】
・工事名：横浜市大型マンション新築内装仕上工事一式
・所在地：神奈川県横浜市西区
・規模：地上18階建て、全120戸
・施工面積：約9,600㎡（全戸合計）
・工期：2025年5月〜2025年10月（予定）
・施工内容：LGS下地工事・ボード工事・壁紙クロス工事・床仕上工事

【施工内容の詳細】
1. 軽鉄下地LGS工事
全120戸の天井・壁下地をLGSで施工します。RC造躯体への適切なアンカー処理を行い、精度の高い下地組みを実現します。

2. ボード工事
石膏ボード二重張りによる高い遮音性能を確保します。住戸間の遮音性能向上のため、特殊遮音ボードも一部採用します。

3. 壁紙クロス工事
各住戸の用途・グレードに応じた壁紙を選定します。消臭・防カビ機能付きの高機能クロスを標準採用し、快適な居住環境を実現します。

4. 床仕上工事
リビング・ダイニングにはフローリング、水回りには防水性の高い長尺シートを採用します。床暖房対応フローリングも一部住戸に導入します。

【品質管理体制】
本プロジェクトでは、専任の品質管理担当者を配置し、各工程の品質検査を徹底します。施工後の検査記録を全戸分作成し、施主への報告書として提出いたします。

株式会社永恒は、本プロジェクトを通じて、高品質な内装仕上工事の提供と、お客様の信頼に応えてまいります。

【お問い合わせ】
株式会社永恒 営業部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://readdy.ai/api/search-image?query=large%20scale%20apartment%20building%20interior%20finishing%20construction%20multiple%20units%20gypsum%20board%20wallpaper%20floor%20installation%20professional%20workers%20team%20modern%20residential%20building%20Yokohama%20Japan%20interior%20renovation%20high%20quality%20craftsmanship&width=800&height=500&seq=news-mansion-004&orientation=landscape',
    tag: '',
  },
  {
    id: 5,
    category: 'お知らせ',
    date: '2025年4月5日',
    title: '2025年度 内装施工技能士 社内資格取得支援制度を拡充いたしました',
    summary: '弊社では、社員の技術力向上と資格取得を支援するため、内装仕上施工技能士・建築施工管理技士などの資格取得支援制度を拡充いたしました。受験費用の全額補助・合格報奨金制度を新設しています。',
    content: `株式会社永恒は、2025年度より社員の技術力向上と資格取得を支援するための制度を大幅に拡充いたしました。

内装仕上工事のプロフェッショナルとして、社員一人ひとりのスキルアップを全力でサポートします。

【拡充内容】
1. 受験費用の全額補助（新設）
これまで50%補助だった受験費用を、2025年度より全額補助に変更いたしました。受験料・テキスト代・講習費用のすべてを会社が負担します。

2. 合格報奨金制度（新設）
資格取得時に以下の報奨金を支給いたします。
・内装仕上施工技能士1級：5万円
・内装仕上施工技能士2級：3万円
・建築施工管理技士1級：10万円
・建築施工管理技士2級：5万円
・宅地建物取引士：5万円

3. 社内勉強会の定期開催（拡充）
月2回の社内勉強会を月4回に増加。技術的な内容だけでなく、法規・安全管理・品質管理についても学べる内容に拡充します。

4. 外部研修への参加支援（新設）
業界団体主催の技術研修・セミナーへの参加費用を全額補助します。年間最大3回まで対応いたします。

【対象資格一覧】
・内装仕上施工技能士（1級・2級）
・建築施工管理技士（1級・2級）
・建築士（1級・2級・木造）
・宅地建物取引士
・石綿作業主任者
・足場の組立て等作業主任者
・玉掛け技能講習修了
・高所作業車運転技能講習修了

【2024年度の資格取得実績】
・内装仕上施工技能士1級：3名合格
・内装仕上施工技能士2級：5名合格
・建築施工管理技士2級：2名合格
・その他安全関連資格：12名取得

弊社は、社員の成長が会社の成長につながると考えています。今後も、社員が安心してキャリアを築ける環境づくりに取り組んでまいります。

【お問い合わせ】
株式会社永恒 人事部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20construction%20workers%20interior%20finishing%20craftsmen%20professional%20training%20certification%20interior%20design%20skills%20development%20team%20meeting%20modern%20office%20bright%20workspace%20professional%20attire%20interior%20construction%20company%20Japan&width=800&height=500&seq=news-training-005&orientation=landscape',
    tag: '',
  },
  {
    id: 6,
    category: 'イベント',
    date: '2025年3月15日',
    title: '千葉県船橋市・RC造マンション全18戸 内装仕上工事が竣工いたしました',
    summary: '千葉県船橋市のRC造新築マンション（全18戸）において、LGS工事・ボード工事・壁紙クロス工事・床仕上工事の内装仕上工事一式が無事竣工いたしました。施主様より高い評価をいただきました。',
    content: `株式会社永恒が施工を担当した、千葉県船橋市のRC造新築マンション（全18戸）の内装仕上工事一式が、2025年3月10日に無事竣工いたしました。

施主様・元請け会社様より「品質・工期・安全管理のすべてにおいて高い水準を維持していただいた」との評価をいただきました。

【工事概要】
・工事名：船橋市RC造マンション新築内装仕上工事一式
・所在地：千葉県船橋市
・規模：全18戸（3LDK〜4LDK）
・施工面積：約1,800㎡
・工期：2024年12月〜2025年3月（約4ヶ月）
・施工内容：LGS下地工事・ボード工事・壁紙クロス工事・床仕上工事

【各工事の施工ポイント】
1. 軽鉄下地LGS工事（約1,800㎡）
RC造躯体への適切なアンカー処理を行い、精度の高い下地組みを実現しました。各戸の間取りに対応した精密な下地組みにより、後工程の施工効率を大幅に向上させました。

2. ボード工事（約1,800㎡）
住戸間の遮音性能確保のため、石膏ボード二重張りを採用しました。水回りには耐水ボードを使用し、長期的な耐久性を確保しています。

3. 壁紙クロス工事（約3,600㎡）
各部屋の用途に合わせた機能性クロスを選定しました。リビング・寝室には消臭・抗菌機能付きクロス、水回りには防カビ・撥水機能付きクロスを採用しています。

4. 床仕上工事（約1,800㎡）
リビング・ダイニング・寝室にはフローリング（床暖房対応）、洗面室・トイレには長尺シートを施工しました。

【施主様からのコメント】
「工期通りに高品質な仕上がりで完工していただき、大変満足しています。特に壁紙の仕上がりの美しさと、床材の施工精度の高さが印象的でした。次のプロジェクトでもぜひお願いしたいと思います。」
（不動産デベロッパー 担当者様）

株式会社永恒は、今後も高品質な内装仕上工事の提供を通じて、お客様の信頼に応えてまいります。

【お問い合わせ】
株式会社永恒 営業部
TEL: 090-6002-2788（受付時間：平日 9:00〜18:00）
Email: satomi102706@gmail.com
所在地：千葉県市川市二俣2-14-18`,
    image: 'https://readdy.ai/api/search-image?query=completed%20apartment%20interior%20finishing%20renovation%20RC%20concrete%20building%20beautiful%20wallpaper%20flooring%20installation%20modern%20Japanese%20residential%20interior%20design%20high%20quality%20craftsmanship%20bright%20clean%20living%20room%20bedroom%20professional%20finish%20Chiba%20Japan&width=800&height=500&seq=news-complete-006&orientation=landscape',
    tag: '',
  },
];

export const categoryColors: Record<string, string> = {
  'プレスリリース': 'bg-[#B8960C]/10 text-[#B8960C]',
  'お知らせ': 'bg-gray-100 text-gray-600',
  'イベント': 'bg-emerald-50 text-emerald-700',
};
